export type FaqItem = { id: string; question: string; answer: string };

export const leftItems: FaqItem[] = [
  {
    id: "left-1",
    question: "How does \"you see it before you pay anything\" actually work?",
    answer:
      "We design your website first so you can see exactly what you're getting before committing. Once you approve the design and are happy with it, you pay. No deposits, no guessing — you're buying something you've already seen.",
  },
  {
    id: "left-2",
    question: "What's the difference between Launch Ready, Launch Plus, and Launch Build?",
    answer:
      "Launch Ready is our monthly subscription for businesses that want a professionally managed site without a big upfront cost. Launch Plus is a mid-range one-time build for growing businesses that need more custom work. Launch Build is our full-service option for businesses that want a high-performing, conversion-focused site built from scratch. Not sure which fits? Let's talk.",
  },
  {
    id: "left-3",
    question: "Do I own my website after it's built?",
    answer:
      "Yes. Once the project is paid for (one-time plans), the site is yours. On the monthly subscription plan, you have full access and the site remains active as long as you're subscribed — similar to how you'd pay for hosting and a maintenance plan.",
  },
  {
    id: "left-4",
    question: "How long does it take to get my website live?",
    answer:
      "Most projects go from kickoff to live in a matter of days, not weeks. We move fast because we've built this process dozens of times. Complex builds take longer, but we'll give you a clear timeline upfront.",
  },
  {
    id: "left-5",
    question: "Do you build Shopify stores or just regular websites?",
    answer:
      "Both. We've increased Shopify store sales by 150% in 90 days for clients, so e-commerce is something we take seriously. Whether you're selling products or services, we build sites that convert.",
  },
  {
    id: "left-6",
    question: "I already have a website. Can you redesign it instead of starting from scratch?",
    answer:
      "Absolutely. Most clients come to us with an existing site that isn't performing. We audit what's broken, redesign it for conversions, and get it working the way it should.",
  },
  {
    id: "left-7",
    question: "What do I need to provide to get started?",
    answer:
      "Ideally: your logo, brand colors if you have them, a general idea of what you want the site to do, and any photos or content you want to include. Don't have everything? We can help fill the gaps — just tell us what you've got.",
  },
  {
    id: "left-8",
    question: "Do you handle SEO?",
    answer:
      "We build every site with SEO best practices baked in — clean structure, fast load times, proper headings, and metadata. Ongoing SEO campaigns (content, link building, etc.) are a separate conversation depending on your goals.",
  },
  {
    id: "left-9",
    question: "What makes you different from just hiring an agency?",
    answer:
      "Most agencies charge $3,000–$5,000+ and hand your project to a junior designer you'll never talk to. Here, you're working directly with someone who's built sites for major brands and is personally accountable for your results. You get agency-quality work without the agency runaround.",
  },
  {
    id: "left-10",
    question: "What if I want changes after the site is live?",
    answer:
      "On the monthly plan, revisions and updates are included. On one-time builds, we include a revision window during the build process. After launch, we can discuss a maintenance arrangement or handle updates on a case-by-case basis.",
  },
];

export const rightItems: FaqItem[] = [
  {
    id: "right-1",
    question: "How fast will I receive my designs?",
    answer:
      "On average, most requests are completed in just two business days or less. However, more complex requests can take longer.",
  },
  {
    id: "right-2",
    question: "How does onboarding work?",
    answer:
      "Subscribe to a plan and we'll quickly add you to your very own Trello board. This process usually takes about an hour to complete from the time you subscribe. Once you accept the invite to Trello, you're ready to rock. Further instructions on how to use the Trello board to request designs can be found on the board itself.",
  },
  {
    id: "right-3",
    question: "Who are the designers?",
    answer:
      "Mind Media is a one-man agency, ran by Wendel, the founder. Mind Media does not employ other designers, or outsource work to any other entity. You'll work directly with me through the entirety of your experience.",
  },
  {
    id: "right-4",
    question: "Is there a limit to how many requests I can make?",
    answer:
      "Once subscribed, you're able to add as many design requests to your queue as you'd like, and they will be delivered one by one.",
  },
  {
    id: "right-5",
    question: "How does the pause feature work?",
    answer:
      "We understand you may not have enough design work to fill up an entire month. Perhaps you only have one or two design requests at the moment. That's where pausing your subscription comes in handy. Billing cycles are based on a 31 day period. Let's say you sign up and use the service for 21 days, and then decide to pause your subscription. This means that the billing cycle will be paused and you'll have 10 days of service remaining to be used anytime in the future.",
  },
  {
    id: "right-6",
    question: "How do you handle larger requests?",
    answer:
      "Larger requests are broken down on Mind Media's end. This applies to full-scale website or mobile app designs, UI/UX work, etc. You should expect to receive a reasonable amount of work every 24-48 hours until the entire request is done.",
  },
  {
    id: "right-7",
    question: "What programs do you design in?",
    answer: "Most requests are designed using Photoshop, Figma, Framer or Illustrator.",
  },
  {
    id: "right-9",
    question: "How will I request designs?",
    answer:
      "Mind Media offers a ton of flexibility in how you request designs using Trello. Some common ways clients request designs is directly via Trello, sharing Google docs or wireframes, or even recording a brief Loom video (for those who prefer not to write their briefs out). Basically, if it can be linked to or shared in Trello, it's fair game.",
  },
  {
    id: "right-10",
    question: "What if I don't like the design?",
    answer: "No worries! We'll continue to revise the design until you're 100% satisfied.",
  },
  {
    id: "right-11",
    question: "Are there any requests you don't support?",
    answer:
      "Absolutely. Mind Media does not cover the following design work: 3D modeling, animated graphics (GIFS, etc.), video, document design (medical forms, etc.), complex packaging, extensive print design (magazines, books, etc.), and Adobe InDesign documents.",
  },
  {
    id: "right-12",
    question: "What if I only have a single request?",
    answer:
      "That's fine. You can pause your subscription when finished and return when you have additional design needs. There's no need to let the remainder of your subscription go to waste.",
  },
  {
    id: "right-13",
    question: "Are there any refunds?",
    answer:
      "Due to the high quality nature of the work, there will be no refunds issued past the first week of service. However, no refunds will be issued for completed work.",
  },
  {
    id: "right-14",
    question: "Can I use Mind Media for just a month?",
    answer:
      "For sure. Whether you need Mind Media for a month or a year, the choice is yours. Just feel free to come back when you have additional design needs.",
  },
];
